// 3. Configuración específica por campo
import { FormModeConfig, FormModeDefaults } from '../../../base/interfaces/formModes.ts'
import { DeaInputProps } from '../interfaces'

export type DeaFormMode = 'create' | 'edit' | 'consult'

/**
 * Exposicion general de los modos
 */
export const deaFormModeDefault: FormModeDefaults<DeaFormMode> = {
  create: { disabled: false, readOnly: true },
  edit: { disabled: false, readOnly: false },
  consult: { disabled: true, readOnly: true },
}

/**
 * Configuracion especifica de lo modos
 * No es obligatorio, el que mantiene prioridad es el default
 */
export const deaFormModeConfig: FormModeConfig<DeaInputProps, DeaFormMode> = {
  descripcion: {
    create: { disabled: true },
    edit: { disabled: true },
    consult: { disabled: true },
  },
}
